import React, { useEffect, useState, useCallback } from "react";
import TextInput from "../../Global Functions/textInput";
import { ReactComponent as CloseIcon } from "../../Global Icons/CancelButton.svg";
// import TwoButtons from "../../Global Functions/buttons";
import { useDispatch } from "react-redux";
import { addLandmark } from "../../Redux/Actions/projectActions";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const AddLandmarks = ({ landmarkData, onClose }) => {
  const [inputLandmark, setInputLandmark] = useState("");
  const [landmarks, setLandmarks] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setLandmarks(landmarkData?.data?.landmarks || []);
  }, [landmarkData]);

  const handleClearAll = useCallback(() => {
    setInputLandmark("");
    setLandmarks([]);
    onClose?.();
  }, [onClose]);

  const handleAddEntry = (event) => {
    event.preventDefault();
    const value = inputLandmark.trim();
    if (!value) return toast.error("Enter landmark name!");
    if (landmarks.includes(value)) return toast.error("Already added!");
    setLandmarks([...landmarks, value]);
    setInputLandmark("");
  };

  const handleInputKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && inputLandmark.trim()) {
      e.preventDefault();
      handleAddEntry(e);
    }
  };

  const handleRemove = (indexToRemove) => {
    setLandmarks(landmarks.filter((_, index) => index !== indexToRemove));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (landmarks.length === 0) {
      return toast.error("Please add at least one landmark!");
    }
    try {
      const addLandmarkData = {
        project_id: landmarkData.data._id,
        landmarks: landmarks,
      };
      const response = await dispatch(addLandmark(addLandmarkData));
      if (response.statusCode === 200) {
        navigate("/manage_projects");
      }
    } catch (error) {
      toast.error(error?.data?.response?.message || "Update failed");
    }
  };

  return (
    <div className="vr-modal-container" style={{
      maxWidth: "540px",
      margin: "0 auto",
      // padding: "40px 20px",
      maxHeight: "90vh",
      overflowY: "auto",
      overflowX: "hidden",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      '&::-webkit-scrollbar': {
        display: "none"
      }
    }}>

      <div className="vr-modal-header" style={{
        marginBottom: "40px",
        paddingBottom: "24px",
        borderBottom: "2px solid #e8eaed",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row"
      }}>
        <div>
          <h2 style={{
            fontSize: "24px",
            fontWeight: "700",
            marginBottom: "8px",
            color: "white",
            letterSpacing: "-0.5px"
          }}>
            Manage Landmarks
          </h2>
          <p style={{
            fontSize: "12px",
            color: "white",
            margin: 0,
            fontWeight: "400"
          }}>
            Add and organize location landmarks for your project
          </p>
        </div>

        <CloseIcon
          className="vr-close-icon"
          onClick={handleClearAll}
          title="Close"
        />
      </div>

      <div style={{ width: "96%", paddingLeft: "27px" }}>
        <div style={{
          marginBottom: 32,
          background: "#ffffff",
          padding: "32px",
          width: "80%",
          borderRadius: "16px",
          border: "1px solid #e8eaed",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)"
        }}>
          <label style={{
            fontWeight: 600,
            fontSize: "15px",
            color: "#202124",
            marginBottom: "12px",
            display: "block",
            letterSpacing: "-0.2px"
          }}>
            Landmark Name
          </label>
          <TextInput
            value={inputLandmark}
            onChange={(e) => setInputLandmark(e.target.value)}
            onKeyDown={handleInputKeyDown}
            placeholder="Enter landmark name and press Enter"
            style={{
              width: "100%",
              padding: "14px 18px",
              marginBottom: "0",
              borderRadius: "10px",
              border: "1.5px solid #dadce0",
              fontSize: "15px",
              transition: "all 0.2s ease",
              outline: "none",
              fontFamily: "inherit",
              backgroundColor: "#fafafa"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#1a73e8";
              e.target.style.backgroundColor = "#ffffff";
              e.target.style.boxShadow = "0 0 0 3px rgba(26, 115, 232, 0.08)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#dadce0";
              e.target.style.backgroundColor = "#fafafa";
              e.target.style.boxShadow = "none";
            }}
          />
          <div style={{
            fontSize: "13px",
            color: "#5f6368",
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "4px"
          }}>
            <span style={{ fontSize: "16px" }}>💡</span>
            Tip: Press Enter or comma to add multiple landmarks quickly
          </div>
        </div>

        {landmarks.length > 0 && (
          <div style={{
            marginBottom: 32,
            background: "#ffffff",
            padding: "32px",
            width: "80%",
            borderRadius: "16px",
            border: "1px solid #e8eaed",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px"
            }}>
              <label style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#202124",
                margin: 0,
                letterSpacing: "-0.2px"
              }}>
                Added Landmarks
              </label>
              <span style={{
                background: "#e8f0fe",
                color: "#1a73e8",
                padding: "4px 12px",
                borderRadius: "12px",
                fontSize: "13px",
                fontWeight: "600"
              }}>
                {landmarks.length} {landmarks.length === 1 ? 'item' : 'items'}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
              }}
            >
              {landmarks.map((landmark, idx) => (
                <div
                  key={landmark + idx}
                  style={{
                    background: "#f8f9fa",
                    color: "#202124",
                    borderRadius: "10px",
                    padding: "10px 16px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight: "500",
                    border: "1px solid #e8eaed",
                    transition: "all 0.2s ease",
                    cursor: "default"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f1f3f4";
                    e.currentTarget.style.borderColor = "#dadce0";
                    e.currentTarget.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#f8f9fa";
                    e.currentTarget.style.borderColor = "#e8eaed";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <span style={{
                    fontSize: "16px",
                    marginRight: "8px",
                    opacity: 0.7
                  }}>
                    📍
                  </span>
                  {landmark}
                  <button
                    onClick={() => handleRemove(idx)}
                    style={{
                      background: "#ea4335",
                      border: "none",
                      marginLeft: "12px",
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "white",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.2s ease",
                      fontWeight: "500"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#d33828";
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#ea4335";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    aria-label={`Remove ${landmark}`}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {landmarks.length === 0 && (
          <div style={{
            background: "#f8f9fa",
            border: "2px dashed #dadce0",
            borderRadius: "16px",
            width: "80%",
            padding: "48px 32px",
            textAlign: "center",
            marginBottom: 32
          }}>
            <div style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.5 }}>📍</div>
            <p style={{
              fontSize: "15px",
              color: "#5f6368",
              margin: 0,
              fontWeight: "500"
            }}>
              No landmarks added yet. Start by entering a landmark name above.
            </p>
          </div>
        )}
      </div>
      <div className="two_buttons" style={{ marginTop: 32, display: "flex", justifyContent: "space-between", padding: "0px 30px 30px 30px" }}>
        <button style={{ background: "linear-gradient(135deg, #172242 0%, #1e3a8a 100%)" }} onClick={handleAddEntry}>
          Add
        </button>
        <button style={{ background: "linear-gradient(135deg, #172242 0%, #1e3a8a 100%)" }} onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default AddLandmarks;
